var _global = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
_global.SENTRY_RELEASE = {
  id: "101b938947e48facb7f2d8a9c01fd0dfb2bd1407"
};
_global.SENTRY_RELEASES = _global.SENTRY_RELEASES || {};
_global.SENTRY_RELEASES["marketing-js@when-i-work"] = {
  id: "101b938947e48facb7f2d8a9c01fd0dfb2bd1407"
};